// Extract validation logic into a reusable function
const validateCart = async (cart) => {
  console.log("Validating cart:", cart);
  const GLASS_JAR_HANDLE = "frische-menue-huhn-mit-reis-im-glas";
  const IS_FROZEN_METAFIELD = "custom.isfrozen";
  let jarCount400g = 0; // Count for 400g variant
  let jarCount800g = 0; // Count for 800g variant
  let frozenCount = 0;

  // Validate cart rules
  for (const item of cart.items) {
    // Rule 1: Count Frische Menüs im Glas by variant
    const isJarProduct =
      item.title.includes("(im Glas)") ||
      item.product_title.includes("(im Glas)");
    const isFrozenProduct =
      item.title.includes("gefroren") ||
      item.product_title.includes("gefroren");
    if (isJarProduct) {
      if (item.variant_title === "400g") {
        jarCount400g += item.quantity;
      } else if (item.variant_title === "800g") {
        jarCount800g += item.quantity;
      }
    }

    if (isFrozenProduct) {
      frozenCount += item.quantity;
    }
  }

  // Prepare messages and validate rules
  const messages = [];
  let disableCheckout = false;

  // Rule 1: Validate multiples of 6 for Frische Menüs im Glas (400g variant)
  if (jarCount400g > 0 && jarCount400g % 6 !== 0) {
    // const shortfall = 6 - (jarCount400g % 6);
    messages.push(
      `Die Mindestbestellmenge für unsere Frische Menüs im Glas beträgt 6 Stück. Du kannst diese in weiteren 6er Schritten (12, 18, 24, ...) bestellen.`,
      // `You must purchase Frische Menüs im Glas (400g) in multiples of 6. You currently have ${jarCount400g}. Add ${shortfall} more to meet the rule.`
    );
    disableCheckout = true;
  }

  // Rule 2: Validate multiples of 6 for Frische Menüs im Glas (800g variant)
  if (jarCount800g > 0 && jarCount800g % 6 !== 0) {
    // const shortfall = 6 - (jarCount800g % 6);
    messages.push(
      `Die Mindestbestellmenge für unsere Frische Menüs im Glas (800g) beträgt 6 Stück. Du kannst diese in weiteren 6er Schritten (12, 18, 24, ...) bestellen. Selbstverständlich sind die verschiedenen Sorten miteinander kombinierbar.`,
      // `You must purchase Frische Menüs im Glas (800g) in multiples of 6. You currently have ${jarCount800g}. Add ${shortfall} more to meet the rule.`,
    );
    disableCheckout = true;
  }

  // Rule 3: Validate minimum 12 frozen items
  if (frozenCount > 0 && frozenCount < 12) {
    // const shortfall = 12 - frozenCount;
    messages.push(
      `Aufgrund des Eigenkühl-Effekts beträgt die Mindestbestellmenge unserer gefrorenen Frische Menüs 12 Stück.`,
      // `You must purchase at least 10 Frische Menüs (frozen). You currently have ${frozenCount}. Add ${shortfall} more to meet the rule.`,
    );
    disableCheckout = true;
  }

  return { messages, disableCheckout };
};

// Function to update the UI
const updateUI = (messages, disableCheckout) => {
  // Display messages
  const feedbackContainer = document.getElementById("cart-feedback");
  if (feedbackContainer) {
    feedbackContainer.innerHTML = "";
    if (messages.length > 0) {
      messages.forEach((message) => {
        const errorDiv = document.createElement("div");
        errorDiv.classList.add("alert", "alert-danger");
        errorDiv.textContent = message;
        feedbackContainer.appendChild(errorDiv);
      });
    }
  }

  // Disable checkout button if validation fails
  const checkoutButton = document.querySelector('[name="checkout"]');
  if (checkoutButton) {
    checkoutButton.disabled = disableCheckout;
  }

  if (messages.length > 0) {
    // add hidden class to cart-feedback if checkout button is disabled
    feedbackContainer.classList.remove("hidden");
  } else {
    // remove hidden class to cart-feedback if checkout button is enabled
    feedbackContainer.classList.add("hidden");
  }
};

// Function to fetch cart data and validate it
const fetchAndValidateCart = async () => {
  try {
    const response = await fetch("/cart.js");
    if (response.ok) {
      const cart = await response.json();
      const { messages, disableCheckout } = await validateCart(cart);
      updateUI(messages, disableCheckout);
    } else {
      console.error("Failed to fetch cart data:", response.statusText);
    }
  } catch (error) {
    console.error("Error fetching cart data:", error);
  }
};

// Subscribe to cart update events
MinimogEvents.subscribe("ON_CART_UPDATE", async (cart) => {
  const { messages, disableCheckout } = await validateCart(cart);
  updateUI(messages, disableCheckout);
});

// Function to initialize the drawer observer
const initializeDrawerObserver = () => {
  // Select the drawer element
  const drawerElement = document.querySelector(".scd__wrapper");

  if (drawerElement) {
    // Create a MutationObserver to watch for changes
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          // Check if the drawer is open or closed
          if (drawerElement.classList.contains("hidden")) {
            console.log("Drawer is closed");
            // Perform your custom logic for when the drawer is closed
          } else {
            console.log("Drawer is opened");
            // Fetch and validate the cart when the drawer is opened
            fetchAndValidateCart();
          }
        }
      });
    });

    // Start observing the drawer element for attribute changes
    observer.observe(drawerElement, {
      attributes: true, // Configure it to listen to attribute changes
    });
  } else {
    console.error("Drawer element not found");
  }
};

// --- Fixed position for Back-in-Stock button on product page ---
// Klaviyo injects the button into #klaviyo-bis-button-container and re-renders it on variant change, often in a different place. We move it into #bis-fixed-container.

const moveBackInStockButton = () => {
  const container = document.getElementById("bis-fixed-container");
  if (!container) return;

  // Klaviyo uses #klaviyo-bis-button-container (prefer this), or .klaviyo-bis-trigger, or theme's .btn-back-in-stock
  const klaviyoContainer = document.getElementById("klaviyo-bis-button-container");
  const klaviyoWrapper = document.querySelector(".klaviyo-bis-trigger:not(.sf__pcard-bis-btn)");
  const bisButton =
    document.querySelector(".btn-back-in-stock") ||
    document.querySelector('button[data-ally-identifier^="bis-button"]') ||
    document.querySelector('button[data-ks-back-in-stock]');

  const nodeToMove =
    klaviyoContainer ||
    (klaviyoWrapper && bisButton && klaviyoWrapper.contains(bisButton) ? klaviyoWrapper : null) ||
    bisButton;

  if (!nodeToMove) return;
  if (container.contains(nodeToMove)) return;

  container.innerHTML = "";
  container.appendChild(nodeToMove);
};

// Run move repeatedly for a short period (Klaviyo often re-injects the button after variant change with a delay)
const scheduleBISMove = () => {
  moveBackInStockButton();
  [100, 300, 600, 1000].forEach((ms) => setTimeout(moveBackInStockButton, ms));
};

// Hide the "Sold out" ATC button so only "Notify me when back in stock" shows; show Add to cart when variant is in stock.
// Sticky ATC bar at bottom: show ONLY when variant is in stock; hide when out of stock.
function hideSoldOutButton() {
  const form = document.querySelector("form.product-form.main-product");
  if (!form) return;
  const atc = form.querySelector(".add-to-cart, button[name='add']");
  if (!atc) return;
  const text = (atc.textContent || "").trim();
  const isSoldOut =
    atc.classList.contains("disabled") ||
    atc.hasAttribute("disabled") ||
    /sold\s*out/i.test(text);

  if (isSoldOut) {
    atc.style.setProperty("display", "none", "important");
  } else {
    atc.style.removeProperty("display");
  }

  // Sticky ATC bar: show only for in-stock variants; hide for out-of-stock
  const stickyBar = document.querySelector(".prod__sticky-atc");
  if (stickyBar) {
    if (isSoldOut) {
      stickyBar.style.setProperty("display", "none", "important");
      document.documentElement.classList.remove("stick-atc-show");
    } else {
      stickyBar.style.removeProperty("display");
    }
  }
}

// Run hideSoldOutButton after theme has updated the ATC (variant change can be async)
function scheduleHideSoldOutButton() {
  hideSoldOutButton();
  [50, 150, 350, 600].forEach(function (ms) {
    setTimeout(hideSoldOutButton, ms);
  });
}

// Keep subscription widget above buy buttons (Appstle may inject at bottom on refresh; move into placeholder)
function moveSubscriptionWidgetIntoPlaceholder() {
  const placeholder = document.getElementById("appstle-subscription-placeholder");
  const widget = document.getElementById("appstle_subscription_widget0");
  if (!placeholder || !widget) return;
  if (placeholder.contains(widget)) return;
  placeholder.appendChild(widget);
}

// Keep product URL in sync with selected variant so refresh preserves state (fixes subscription/out-of-stock layout)
function getUrlWithVariant(url, variantId) {
  if (!variantId) return url;
  const base = url.split("?")[0];
  const search = new URLSearchParams(window.location.search);
  search.set("variant", String(variantId));
  return base + "?" + search.toString();
}

function updateProductUrlFromForm() {
  const form = document.querySelector("form.product-form.main-product");
  if (!form) return;
  const idInput = form.querySelector('input[name="id"]');
  if (!idInput) return;
  const variantId = idInput.value && idInput.value.trim();
  if (!variantId) return;
  const newUrl = getUrlWithVariant(window.location.href, variantId);
  if (newUrl !== window.location.href) {
    window.history.replaceState({ path: newUrl }, "", newUrl);
  }
}

const initializeBackInStockPositioning = () => {
  const tpl = document.documentElement.getAttribute("data-template");
  if (tpl !== "product") return;

  scheduleBISMove();

  const root = document.querySelector(".main-product__blocks");
  if (!root || root._bisObserverAttached) return;
  root._bisObserverAttached = true;

  const observer = new MutationObserver(() => {
    scheduleBISMove();
    updateProductUrlFromForm();
    hideSoldOutButton();
    moveSubscriptionWidgetIntoPlaceholder();
  });
  observer.observe(root, { childList: true, subtree: true });

  hideSoldOutButton();
  moveSubscriptionWidgetIntoPlaceholder();
  [100, 300, 600, 1500].forEach((ms) => setTimeout(moveSubscriptionWidgetIntoPlaceholder, ms));

  const form = root && root.closest("form.product-form");
  if (form) {
    form.addEventListener("change", () => {
      scheduleBISMove();
      updateProductUrlFromForm();
      scheduleHideSoldOutButton();
      moveSubscriptionWidgetIntoPlaceholder();
    });
    form.addEventListener("input", () => {
      scheduleBISMove();
      updateProductUrlFromForm();
      scheduleHideSoldOutButton();
      moveSubscriptionWidgetIntoPlaceholder();
    });
    // Always keep URL in sync with selected variant (theme may not update URL; refresh then loses state)
    const productId = form.dataset.productId;
    if (productId && typeof MinimogEvents !== "undefined" && MinimogEvents.subscribe) {
      MinimogEvents.subscribe(productId + "__VARIANT_CHANGE", (variant) => {
        if (variant && variant.id) {
          const newUrl = getUrlWithVariant(window.location.href, variant.id);
          if (newUrl !== window.location.href) {
            window.history.replaceState({ path: newUrl }, "", newUrl);
          }
        }
        scheduleHideSoldOutButton();
      });
    }
    updateProductUrlFromForm();
  }
};

// Klaviyo "Back in Stock - Fidelis Dog" popup (same form as the product page)
const KLAVIYO_BIS_FORM_ID = "SQVK9a";

function setKlaviyoProductContextFromCard(btn) {
  const variantId = btn.getAttribute("data-variant-id");
  const productId = btn.getAttribute("data-product-id");
  if (!variantId || !productId) return;

  const meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
  if (meta) {
    meta.selectedVariantId = String(variantId);
    meta.product = meta.product || {};
    meta.product.id = Number(productId);
    meta.product.gid = "gid://shopify/Product/" + productId;
    meta.product.variants = [{ id: Number(variantId), gid: "gid://shopify/ProductVariant/" + variantId }];
    meta.page = meta.page || {};
    meta.page.resourceId = Number(productId);
  }

  const form = btn.closest("form");
  const idInput = form && form.querySelector('input[name="id"]');
  if (idInput) idInput.value = String(variantId);
}

function openKlaviyoBisPopup() {
  window._klOnsite = window._klOnsite || [];
  if (!window.klaviyo) window.klaviyo = window._klOnsite;
  try {
    if (typeof window.klaviyo.openForm === "function") {
      window.klaviyo.openForm(KLAVIYO_BIS_FORM_ID);
      return;
    }
  } catch (e) {}
  window._klOnsite.push(["openForm", KLAVIYO_BIS_FORM_ID]);
}

function initializeCollectionBackInStock() {
  document.addEventListener(
    "click",
    (event) => {
      const btn = event.target && event.target.closest && event.target.closest(".sf__pcard-bis-btn");
      if (!btn) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function") event.stopImmediatePropagation();

      setKlaviyoProductContextFromCard(btn);
      openKlaviyoBisPopup();
    },
    true
  );
}

function initializeScript() {
  initializeDrawerObserver();
  initializeBackInStockPositioning();
  initializeCollectionBackInStock();

  // --- B2B collection cards: variant picker updates ATC + price ---
  // This is intentionally lightweight and scoped to cards that render the B2B dropdown.
  document.addEventListener("change", (event) => {
    const select = event.target && event.target.closest && event.target.closest("select.b2b-variant-select");
    if (!select) return;

    const card = select.closest(".sf__pcard");
    if (!card) return;

    const opt = select.options && select.selectedIndex >= 0 ? select.options[select.selectedIndex] : null;
    if (!opt) return;

    const idInput = card.querySelector('input[name="id"][data-b2b-card-variant-id]');
    if (idInput) idInput.value = String(opt.value || "").trim();

    const priceEl = card.querySelector("[data-b2b-card-price]");
    if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;

    const compareEl = card.querySelector("[data-b2b-card-compare-price]");
    if (compareEl) {
      const hasCompare = opt.dataset.hasCompare === "true";
      if (hasCompare && opt.dataset.comparePrice) {
        compareEl.textContent = opt.dataset.comparePrice;
        compareEl.classList.remove("hidden");
      } else {
        compareEl.classList.add("hidden");
      }
    }

    const unitEl = card.querySelector("[data-b2b-card-unit-price]");
    if (unitEl) unitEl.textContent = opt.dataset.unitPrice || "";
  });

  // --- B2B collection cards: open a modal to pick variant + qty ---
  function getOrCreateB2BVariantModal() {
    let modal = document.getElementById("b2b-variant-modal");
    if (modal) return modal;

    modal = document.createElement("div");
    modal.id = "b2b-variant-modal";
    modal.className = "b2b-variant-modal hidden";
    modal.innerHTML = `
      <div class="b2b-variant-modal__backdrop" data-b2b-modal-close></div>
      <div class="b2b-variant-modal__dialog" role="dialog" aria-modal="true" aria-label="Select options">
        <button type="button" class="b2b-variant-modal__close" aria-label="Close" data-b2b-modal-close>&times;</button>
        <div class="b2b-variant-modal__content">
          <div class="b2b-variant-modal__title" data-b2b-modal-title></div>
          <div class="b2b-variant-modal__row">
            <label class="b2b-variant-modal__label">Variant</label>
            <fieldset class="b2b-variant-modal__fieldset" data-b2b-modal-variants></fieldset>
          </div>
          <div class="b2b-variant-modal__row">
            <label class="b2b-variant-modal__label">Quantity</label>
            <div class="quantity-input h-[46px] flex border border-color-border rounded b2b-variant-modal__qtywrap">
              <button
                class="quantity-input__button flex items-center justify-center h-[46px] w-[46px]"
                type="button"
                aria-label="Decrease quantity"
                data-b2b-modal-qty-btn="decrease"
              >
                -
              </button>
              <input
                class="quantity-input__element w-10 text-center flex-grow shrink appearance-none b2b-variant-modal__qty"
                type="number"
                name="quantity"
                value="1"
                min="1"
                aria-label="Quantity"
                data-b2b-modal-qty
              >
              <button
                class="quantity-input__button flex items-center justify-center h-[46px] w-[46px]"
                type="button"
                aria-label="Increase quantity"
                data-b2b-modal-qty-btn="increase"
              >
                +
              </button>
            </div>
          </div>
          <div class="b2b-variant-modal__row b2b-variant-modal__row--total">
            <label class="b2b-variant-modal__label">Total</label>
            <div class="b2b-variant-modal__total" data-b2b-modal-total>—</div>
          </div>
          <div class="b2b-variant-modal__actions">
            <button type="button" class="sf__btn sf__btn-primary b2b-variant-modal__add" data-b2b-modal-add>Add to cart</button>
          </div>
        </div>
      </div>
    `;

    document.body.appendChild(modal);

    modal.addEventListener("click", (e) => {
      if (e.target && e.target.closest && e.target.closest("[data-b2b-modal-close]")) {
        modal.classList.add("hidden");
        modal.removeAttribute("data-card-id");
      }
    });

    modal.addEventListener("click", (e) => {
      const btn = e.target && e.target.closest && e.target.closest("[data-b2b-modal-qty-btn]");
      if (!btn) return;
      const dir = btn.getAttribute("data-b2b-modal-qty-btn");
      const qty = modal.querySelector("[data-b2b-modal-qty]");
      if (!qty) return;
      const current = parseInt(qty.value || "1", 10) || 1;
      const next = dir === "decrease" ? Math.max(1, current - 1) : current + 1;
      qty.value = String(next);
      updateB2BModalTotal(modal);
    });

    modal.addEventListener("input", (e) => {
      if (e.target && (e.target.matches("[data-b2b-modal-qty]") || e.target.closest("[data-b2b-modal-variants]"))) {
        updateB2BModalTotal(modal);
      }
    });

    modal.addEventListener("change", (e) => {
      if (e.target && (e.target.matches("[data-b2b-modal-qty]") || e.target.closest("[data-b2b-modal-variants]"))) {
        updateB2BModalTotal(modal);
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && !modal.classList.contains("hidden")) {
        modal.classList.add("hidden");
        modal.removeAttribute("data-card-id");
      }
    });

    return modal;
  }

  function formatMoneySafe(cents) {
    const value = typeof cents === "number" ? cents : parseInt(String(cents || "0"), 10) || 0;
    if (typeof Shopify !== "undefined" && typeof Shopify.formatMoney === "function") {
      const fmt =
        (window.MinimogSettings && window.MinimogSettings.money_format) ||
        (window.MinimogSettings && window.MinimogSettings.money_with_currency_format) ||
        "${{amount}}";
      return Shopify.formatMoney(value, fmt);
    }

    const fmt =
      (window.MinimogSettings && window.MinimogSettings.money_format) ||
      (window.MinimogSettings && window.MinimogSettings.money_with_currency_format) ||
      "${{amount}}";

    // Very small fallback: replace {{amount}} with a 2dp number.
    const amount = (value / 100).toFixed(2);
    return fmt.replace("{{amount}}", amount).replace("{{ amount }}", amount);
  }

  function getB2BModalSelectedPriceCents(modal) {
    const checked = modal.querySelector('[data-b2b-modal-variants] input[type="radio"]:checked');
    if (!checked) return null;
    const cents = checked.dataset.priceCents;
    return cents != null ? parseInt(String(cents), 10) : null;
  }

  function getB2BModalQty(modal) {
    const qtyEl = modal.querySelector("[data-b2b-modal-qty]");
    const qty = qtyEl ? parseInt(String(qtyEl.value || "1"), 10) : 1;
    return Math.max(1, qty || 1);
  }

  function updateB2BModalTotal(modal) {
    const totalEl = modal.querySelector("[data-b2b-modal-total]");
    if (!totalEl) return;
    const priceCents = getB2BModalSelectedPriceCents(modal);
    if (priceCents == null || Number.isNaN(priceCents)) {
      totalEl.textContent = "—";
      return;
    }
    const qty = getB2BModalQty(modal);
    totalEl.textContent = formatMoneySafe(priceCents * qty);
  }

  function buildVariantRadioHTML(optionEl, groupName, checked) {
    const title = (optionEl.textContent || "").trim();
    const price = optionEl.dataset.price || "";
    const compare = optionEl.dataset.comparePrice || "";
    const hasCompare = optionEl.dataset.hasCompare === "true";
    const disabled = optionEl.disabled ? "disabled" : "";
    const isChecked = checked ? "checked" : "";

    const priceHtml = hasCompare && compare
      ? `<span class="b2b-variant-modal__price"><span class="b2b-variant-modal__price-compare">${compare}</span><span class="b2b-variant-modal__price-current">${price}</span></span>`
      : `<span class="b2b-variant-modal__price"><span class="b2b-variant-modal__price-current">${price}</span></span>`;

    // Store all useful data-* on the input so we can use it later.
    const datasetAttrs = Object.entries(optionEl.dataset || {})
      .map(([k, v]) => `data-${k.replace(/[A-Z]/g, (m) => "-" + m.toLowerCase())}="${String(v).replaceAll('"', "&quot;")}"`)
      .join(" ");

    return `
      <label class="b2b-variant-modal__radio ${optionEl.disabled ? "is-disabled" : ""}">
        <input type="radio" name="${groupName}" value="${optionEl.value}" ${isChecked} ${disabled} ${datasetAttrs} />
        <span class="b2b-variant-modal__radio-body">
          <span class="b2b-variant-modal__radio-title">${title}</span>
          ${priceHtml}
        </span>
      </label>
    `;
  }

  function openB2BVariantModal(card) {
    const modal = getOrCreateB2BVariantModal();
    const cardId = card.getAttribute("data-b2b-card-id") || String(Date.now());
    card.setAttribute("data-b2b-card-id", cardId);
    modal.setAttribute("data-card-id", cardId);

    const titleEl = modal.querySelector("[data-b2b-modal-title]");
    const productTitle =
      (card.querySelector(".product-title-custom") && card.querySelector(".product-title-custom").textContent) ||
      (card.querySelector(".sf__pcard-name") && card.querySelector(".sf__pcard-name").textContent) ||
      "Select options";
    if (titleEl) titleEl.textContent = (productTitle || "").trim();

    const cardSelect = card.querySelector("select.b2b-variant-select");
    const variantsBox = modal.querySelector("[data-b2b-modal-variants]");
    if (cardSelect && variantsBox) {
      const groupName = "b2b_variant_" + cardId;
      variantsBox.innerHTML = "";
      Array.from(cardSelect.options).forEach((o) => {
        variantsBox.insertAdjacentHTML("beforeend", buildVariantRadioHTML(o, groupName, o.selected));
      });
    }

    const qtyInput = modal.querySelector("[data-b2b-modal-qty]");
    const cardQty = card.querySelector('input[name="quantity"][data-quantity-input]');
    if (qtyInput) qtyInput.value = (cardQty && cardQty.value ? cardQty.value : "1");

    const addBtn = modal.querySelector("[data-b2b-modal-add]");
    if (addBtn && !addBtn._b2bBound) {
      addBtn._b2bBound = true;
      addBtn.addEventListener("click", () => {
        const activeCardId = modal.getAttribute("data-card-id");
        if (!activeCardId) return;
        const activeCard = document.querySelector(`.sf__pcard[data-b2b-card-id="${activeCardId}"]`);
        if (!activeCard) return;

        const mRadio = modal.querySelector('[data-b2b-modal-variants] input[type="radio"]:checked');
        const mQty = modal.querySelector("[data-b2b-modal-qty]");
        const form = activeCard.querySelector("form.product-form");
        if (!form || !mRadio) return;

        // Apply variant selection back to card
        const cSelect = activeCard.querySelector("select.b2b-variant-select");
        if (cSelect) {
          cSelect.value = mRadio.value;
          cSelect.dispatchEvent(new Event("change", { bubbles: true }));
        }

        // Apply quantity back to card
        const cQty = activeCard.querySelector('input[name="quantity"][data-quantity-input]');
        if (cQty && mQty) cQty.value = String(Math.max(1, parseInt(mQty.value || "1", 10) || 1));

        // Allow submit through and submit
        form.setAttribute("data-b2b-modal-confirmed", "true");
        try {
          form.requestSubmit();
        } catch (_) {
          form.submit();
        }
        form.removeAttribute("data-b2b-modal-confirmed");

        modal.classList.add("hidden");
        modal.removeAttribute("data-card-id");
      });
    }

    modal.classList.remove("hidden");
    updateB2BModalTotal(modal);
    const firstFocus =
      modal.querySelector('[data-b2b-modal-variants] input[type="radio"]:checked') ||
      modal.querySelector('[data-b2b-modal-variants] input[type="radio"]') ||
      modal.querySelector("[data-b2b-modal-qty]");
    if (firstFocus) {
      try {
        firstFocus.focus({ preventScroll: true });
      } catch (_) {
        firstFocus.focus();
      }
    }
  }

  // Intercept ATC click (B2B cards only) and open modal instead of adding immediately.
  document.addEventListener(
    "click",
    (event) => {
      const btn = event.target && event.target.closest && event.target.closest('button[name="add"].add-to-cart');
      if (!btn) return;
      const card = btn.closest(".sf__pcard");
      if (!card) return;
      const cardSelect = card.querySelector("select.b2b-variant-select");
      if (!cardSelect) return; // not B2B card

      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();

      openB2BVariantModal(card);
    },
    true,
  );

  // Block programmatic submits from adding default variant (unless modal confirmed).
  document.addEventListener(
    "submit",
    (event) => {
      const form = event.target;
      if (!form || !(form instanceof HTMLFormElement)) return;
      if (form.getAttribute("data-b2b-modal-confirmed") === "true") return;

      const card = form.closest && form.closest(".sf__pcard");
      if (!card) return;
      const cardSelect = card.querySelector("select.b2b-variant-select");
      if (!cardSelect) return;

      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      openB2BVariantModal(card);
    },
    true,
  );

  // Set up a polling function that periodically checks if the cart drawer exists
  setInterval(() => {
    const drawerElement = document.querySelector(".scd__wrapper");
    if (drawerElement && !drawerElement._hasObserver) {
      drawerElement._hasObserver = true;
      initializeDrawerObserver();
    }

    // On product page, keep the Back-in-Stock button anchored, URL in sync, Sold out hidden, subscription in placeholder
    if (document.documentElement.getAttribute("data-template") === "product") {
      moveBackInStockButton();
      updateProductUrlFromForm();
      hideSoldOutButton();
      moveSubscriptionWidgetIntoPlaceholder();
    }
  }, 1000); // Check every second
}

// Initialize the script when the DOM is loaded
document.addEventListener("DOMContentLoaded", initializeScript);

// Also try to initialize on Shopify events
document.addEventListener("page:load", initializeScript);
document.addEventListener("shopify:section:load", () => {
  initializeBackInStockPositioning();
});


// If the drawer is dynamically added to the DOM, use a MutationObserver to detect when it's added
const dynamicDrawerObserver = new MutationObserver(
  (mutationsList, observer) => {
    const drawerElement = document.querySelector(".scd__wrapper");
    if (drawerElement) {
      initializeDrawerObserver();
      // observer.disconnect(); // Stop observing once the drawer is found
    }
  },
);

// Start observing the document body for changes
dynamicDrawerObserver.observe(document.body, {
  childList: true,
  subtree: true,
});
